import { Sparkles, Check } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useSubscription } from '@/hooks/useSubscription';
import { PRICING } from '@/lib/subscription';
import { Link } from 'react-router-dom';

interface UpgradeModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  featureName?: string;
}

const premiumBenefits = [
  'Cuentas bancarias ilimitadas (importación PDF)',
  'Bola de nieve y estrategia de deudas',
  'Metas financieras y fondo de emergencia',
  'Topes de gastos con alertas',
  'Notificaciones por email',
  'Detalle completo del FOCO Score',
  'Chat con asesoría IA',
];

export function UpgradeModal({ open, onOpenChange, featureName }: UpgradeModalProps) {
  const { startCheckout, checkoutLoading, isPremium } = useSubscription();

  if (isPremium) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Sparkles className="h-5 w-5 text-primary" />
            Actualiza a Premium
          </DialogTitle>
          <DialogDescription>
            {featureName
              ? `${featureName} es una función Premium.`
              : 'Desbloquea todo el potencial de FOCO AI.'}
          </DialogDescription>
        </DialogHeader>

        <ul className="space-y-2 text-sm">
          {premiumBenefits.map((item) => (
            <li key={item} className="flex items-start gap-2">
              <Check className="h-4 w-4 text-success shrink-0 mt-0.5" />
              <span>{item}</span>
            </li>
          ))}
        </ul>

        <div className="grid gap-2 pt-2">
          <Button
            onClick={() => startCheckout('monthly')}
            disabled={checkoutLoading}
            className="w-full"
            size="lg"
          >
            Activar Premium — {PRICING.monthly.label}
          </Button>
        </div>

        <Button variant="link" asChild className="w-full">
          <Link to="/upgrade" onClick={() => onOpenChange(false)}>
            Ver comparación completa
          </Link>
        </Button>
      </DialogContent>
    </Dialog>
  );
}
